module.exports = __webpack_public_path__ + "static/media/trash.3b347171.svg";